/* eslint @typescript-eslint/no-redundant-type-constituents: 0 */
import { IntlMessageFormat } from 'intl-messageformat';

const _signup_fr = new IntlMessageFormat([{ type: 0, value: "S'inscrire" }], 'fr');

const _signup_en = new IntlMessageFormat([{ type: 0, value: 'Sign up' }], 'en');

export function signup(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _signup_fr.format(args) as unknown as string;
    }

    if (lang.startsWith('en')) {
        return _signup_en.format(args) as unknown as string;
    }

    return _signup_fr.format(args) as unknown as string;
}

const _signin_fr = new IntlMessageFormat([{ type: 0, value: 'Se connecter' }], 'fr');

const _signin_en = new IntlMessageFormat([{ type: 0, value: 'Sign in' }], 'en');

export function signin(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _signin_fr.format(args) as unknown as string;
    }

    if (lang.startsWith('en')) {
        return _signin_en.format(args) as unknown as string;
    }

    return _signin_fr.format(args) as unknown as string;
}

const _signout_fr = new IntlMessageFormat([{ type: 0, value: 'Se déconnecter' }], 'fr');

const _signout_en = new IntlMessageFormat([{ type: 0, value: 'Sign out' }], 'en');

export function signout(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _signout_fr.format(args) as unknown as string;
    }

    if (lang.startsWith('en')) {
        return _signout_en.format(args) as unknown as string;
    }

    return _signout_fr.format(args) as unknown as string;
}

const _super_app_fr = new IntlMessageFormat([{ type: 0, value: 'Super app' }], 'fr');

const _super_app_en = new IntlMessageFormat([{ type: 0, value: 'Super app' }], 'en');

export function super_app(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _super_app_fr.format(args) as unknown as string;
    }

    if (lang.startsWith('en')) {
        return _super_app_en.format(args) as unknown as string;
    }

    return _super_app_fr.format(args) as unknown as string;
}

const _our_services_fr = new IntlMessageFormat(
    [{ type: 0, value: 'Nos services' }],
    'fr',
);

const _our_services_en = new IntlMessageFormat(
    [{ type: 0, value: 'Our services' }],
    'en',
);

export function our_services(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _our_services_fr.format(args) as unknown as string;
    }

    if (lang.startsWith('en')) {
        return _our_services_en.format(args) as unknown as string;
    }

    return _our_services_fr.format(args) as unknown as string;
}

const _services_fr = new IntlMessageFormat([{ type: 0, value: 'Services' }], 'fr');

const _services_en = new IntlMessageFormat([{ type: 0, value: 'Services' }], 'en');

export function services(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _services_fr.format(args) as unknown as string;
    }

    if (lang.startsWith('en')) {
        return _services_en.format(args) as unknown as string;
    }

    return _services_fr.format(args) as unknown as string;
}

const _companies_fr = new IntlMessageFormat([{ type: 0, value: 'Entreprises' }], 'fr');

const _companies_en = new IntlMessageFormat([{ type: 0, value: 'Companies' }], 'en');

export function companies(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _companies_fr.format(args) as unknown as string;
    }

    if (lang.startsWith('en')) {
        return _companies_en.format(args) as unknown as string;
    }

    return _companies_fr.format(args) as unknown as string;
}

const _network_fr = new IntlMessageFormat([{ type: 0, value: 'Réseau' }], 'fr');

const _network_en = new IntlMessageFormat([{ type: 0, value: 'Network' }], 'en');

export function network(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _network_fr.format(args) as unknown as string;
    }

    if (lang.startsWith('en')) {
        return _network_en.format(args) as unknown as string;
    }

    return _network_fr.format(args) as unknown as string;
}

const _talents_fr = new IntlMessageFormat([{ type: 0, value: 'Talents' }], 'fr');

const _talents_en = new IntlMessageFormat([{ type: 0, value: 'Talents' }], 'en');

export function talents(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _talents_fr.format(args) as unknown as string;
    }

    if (lang.startsWith('en')) {
        return _talents_en.format(args) as unknown as string;
    }

    return _talents_fr.format(args) as unknown as string;
}

const _job_fr = new IntlMessageFormat([{ type: 0, value: 'Emploi' }], 'fr');

const _job_en = new IntlMessageFormat([{ type: 0, value: 'Job' }], 'en');

export function job(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _job_fr.format(args) as unknown as string;
    }

    if (lang.startsWith('en')) {
        return _job_en.format(args) as unknown as string;
    }

    return _job_fr.format(args) as unknown as string;
}

const _contact_fr = new IntlMessageFormat([{ type: 0, value: 'Contact' }], 'fr');

const _contact_en = new IntlMessageFormat([{ type: 0, value: 'Contact us' }], 'en');

export function contact(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _contact_fr.format(args) as unknown as string;
    }

    if (lang.startsWith('en')) {
        return _contact_en.format(args) as unknown as string;
    }

    return _contact_fr.format(args) as unknown as string;
}

const _countries_fr = new IntlMessageFormat([{ type: 0, value: 'Pays' }], 'fr');

const _countries_en = new IntlMessageFormat([{ type: 0, value: 'Countries' }], 'en');

export function countries(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _countries_fr.format(args) as unknown as string;
    }

    if (lang.startsWith('en')) {
        return _countries_en.format(args) as unknown as string;
    }

    return _countries_fr.format(args) as unknown as string;
}

const _select_country_fr = new IntlMessageFormat(
    [{ type: 0, value: 'Sélectionnez votre pays' }],
    'fr',
);

const _select_country_en = new IntlMessageFormat(
    [{ type: 0, value: 'Select your country' }],
    'en',
);

export function select_country(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _select_country_fr.format(args) as unknown as string;
    }

    if (lang.startsWith('en')) {
        return _select_country_en.format(args) as unknown as string;
    }

    return _select_country_fr.format(args) as unknown as string;
}

const _africa_fr = new IntlMessageFormat([{ type: 0, value: 'Afrique' }], 'fr');

const _africa_en = new IntlMessageFormat([{ type: 0, value: 'Africa' }], 'en');

export function africa(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _africa_fr.format(args) as unknown as string;
    }

    if (lang.startsWith('en')) {
        return _africa_en.format(args) as unknown as string;
    }

    return _africa_fr.format(args) as unknown as string;
}

const _to_admin_fr = new IntlMessageFormat([{ type: 0, value: "Console d'admin" }], 'fr');

const _to_admin_en = new IntlMessageFormat([{ type: 0, value: 'To admin' }], 'en');

export function to_admin(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _to_admin_fr.format(args) as unknown as string;
    }

    if (lang.startsWith('en')) {
        return _to_admin_en.format(args) as unknown as string;
    }

    return _to_admin_fr.format(args) as unknown as string;
}

const _my_profile_fr = new IntlMessageFormat([{ type: 0, value: 'Mon profil' }], 'fr');

const _my_profile_en = new IntlMessageFormat([{ type: 0, value: 'My profile' }], 'en');

export function my_profile(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _my_profile_fr.format(args) as unknown as string;
    }

    if (lang.startsWith('en')) {
        return _my_profile_en.format(args) as unknown as string;
    }

    return _my_profile_fr.format(args) as unknown as string;
}

const _edit_my_profile_fr = new IntlMessageFormat(
    [{ type: 0, value: 'Éditer mon profil' }],
    'fr',
);

const _edit_my_profile_en = new IntlMessageFormat(
    [{ type: 0, value: 'Edit my profile' }],
    'en',
);

export function edit_my_profile(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _edit_my_profile_fr.format(args) as unknown as string;
    }

    if (lang.startsWith('en')) {
        return _edit_my_profile_en.format(args) as unknown as string;
    }

    return _edit_my_profile_fr.format(args) as unknown as string;
}

const _edit_or_create_companies_fr = new IntlMessageFormat(
    [
        {
            type: 6,
            value: 'nb',
            options: {
                '=0': { value: [{ type: 0, value: 'Créer une société' }] },
                '=1': { value: [{ type: 0, value: 'Éditer ma société' }] },
                other: { value: [{ type: 0, value: 'Gérer mes sociétés' }] },
            },
            offset: 0,
            pluralType: 'cardinal',
        },
        { type: 0, value: '\n' },
    ],
    'fr',
);

const _edit_or_create_companies_en = new IntlMessageFormat(
    [
        {
            type: 6,
            value: 'nb',
            options: {
                '=0': { value: [{ type: 0, value: 'Create one company' }] },
                '=1': { value: [{ type: 0, value: 'Edit my company' }] },
                other: { value: [{ type: 0, value: 'Manage my companies' }] },
            },
            offset: 0,
            pluralType: 'cardinal',
        },
        { type: 0, value: '\n' },
    ],
    'en',
);

export function edit_or_create_companies(args: { nb: number }, lang: string): string {
    if (lang.startsWith('fr')) {
        return _edit_or_create_companies_fr.format(args) as unknown as string;
    }

    if (lang.startsWith('en')) {
        return _edit_or_create_companies_en.format(args) as unknown as string;
    }

    return _edit_or_create_companies_fr.format(args) as unknown as string;
}

const _messaging_fr = new IntlMessageFormat([{ type: 0, value: 'Messagerie' }], 'fr');

const _messaging_en = new IntlMessageFormat([{ type: 0, value: 'Inbox' }], 'en');

export function messaging(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _messaging_fr.format(args) as unknown as string;
    }

    if (lang.startsWith('en')) {
        return _messaging_en.format(args) as unknown as string;
    }

    return _messaging_fr.format(args) as unknown as string;
}

const _messaging_x_fr = new IntlMessageFormat(
    [
        { type: 0, value: 'Messagerie ' },
        { type: 2, value: 'nb', style: 'integer' },
    ],
    'fr',
);

const _messaging_x_en = new IntlMessageFormat(
    [
        { type: 0, value: 'Inbox ' },
        { type: 2, value: 'nb', style: 'integer' },
    ],
    'en',
);

export function messaging_x(args: { nb: number }, lang: string): string {
    if (lang.startsWith('fr')) {
        return _messaging_x_fr.format(args) as unknown as string;
    }

    if (lang.startsWith('en')) {
        return _messaging_x_en.format(args) as unknown as string;
    }

    return _messaging_x_fr.format(args) as unknown as string;
}

const _menu_fr = new IntlMessageFormat([{ type: 0, value: 'Menu' }], 'fr');

const _menu_en = new IntlMessageFormat([{ type: 0, value: 'Menu' }], 'en');

export function menu(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _menu_fr.format(args) as unknown as string;
    }

    if (lang.startsWith('en')) {
        return _menu_en.format(args) as unknown as string;
    }

    return _menu_fr.format(args) as unknown as string;
}

const _notification_fr = new IntlMessageFormat(
    [{ type: 0, value: 'Notification' }],
    'fr',
);

const _notification_en = new IntlMessageFormat(
    [{ type: 0, value: 'Notification' }],
    'en',
);

export function notification(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _notification_fr.format(args) as unknown as string;
    }

    if (lang.startsWith('en')) {
        return _notification_en.format(args) as unknown as string;
    }

    return _notification_fr.format(args) as unknown as string;
}

const _notification_see_all_fr = new IntlMessageFormat(
    [{ type: 0, value: 'Voir tout' }],
    'fr',
);

const _notification_see_all_en = new IntlMessageFormat(
    [{ type: 0, value: 'See all' }],
    'en',
);

export function notification_see_all(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _notification_see_all_fr.format(args) as unknown as string;
    }

    if (lang.startsWith('en')) {
        return _notification_see_all_en.format(args) as unknown as string;
    }

    return _notification_see_all_fr.format(args) as unknown as string;
}

const _super_app_company_fr = new IntlMessageFormat(
    [{ type: 0, value: 'Entreprise' }],
    'fr',
);

const _super_app_company_en = new IntlMessageFormat(
    [{ type: 0, value: 'Company' }],
    'en',
);

export function super_app_company(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _super_app_company_fr.format(args) as unknown as string;
    }

    if (lang.startsWith('en')) {
        return _super_app_company_en.format(args) as unknown as string;
    }

    return _super_app_company_fr.format(args) as unknown as string;
}

const _super_app_pro_fr = new IntlMessageFormat(
    [{ type: 0, value: 'Professionnels' }],
    'fr',
);

const _super_app_pro_en = new IntlMessageFormat([{ type: 0, value: 'Pro' }], 'en');

export function super_app_pro(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _super_app_pro_fr.format(args) as unknown as string;
    }

    if (lang.startsWith('en')) {
        return _super_app_pro_en.format(args) as unknown as string;
    }

    return _super_app_pro_fr.format(args) as unknown as string;
}

const _super_app_social_network_fr = new IntlMessageFormat(
    [{ type: 0, value: 'Réseau social' }],
    'fr',
);

const _super_app_social_network_en = new IntlMessageFormat(
    [{ type: 0, value: 'Network' }],
    'en',
);

export function super_app_social_network(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _super_app_social_network_fr.format(args) as unknown as string;
    }

    if (lang.startsWith('en')) {
        return _super_app_social_network_en.format(args) as unknown as string;
    }

    return _super_app_social_network_fr.format(args) as unknown as string;
}

const _super_app_messaging_fr = new IntlMessageFormat(
    [{ type: 0, value: 'Messagerie privée' }],
    'fr',
);

const _super_app_messaging_en = new IntlMessageFormat(
    [{ type: 0, value: 'Private messaging' }],
    'en',
);

export function super_app_messaging(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _super_app_messaging_fr.format(args) as unknown as string;
    }

    if (lang.startsWith('en')) {
        return _super_app_messaging_en.format(args) as unknown as string;
    }

    return _super_app_messaging_fr.format(args) as unknown as string;
}

const _super_app_job_fr = new IntlMessageFormat([{ type: 0, value: 'Emploi' }], 'fr');

const _super_app_job_en = new IntlMessageFormat([{ type: 0, value: 'Job' }], 'en');

export function super_app_job(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _super_app_job_fr.format(args) as unknown as string;
    }

    if (lang.startsWith('en')) {
        return _super_app_job_en.format(args) as unknown as string;
    }

    return _super_app_job_fr.format(args) as unknown as string;
}

const _super_app_media_cms_fr = new IntlMessageFormat(
    [{ type: 0, value: 'Médias / Articles' }],
    'fr',
);

const _super_app_media_cms_en = new IntlMessageFormat(
    [{ type: 0, value: 'Media / Articles' }],
    'en',
);

export function super_app_media_cms(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _super_app_media_cms_fr.format(args) as unknown as string;
    }

    if (lang.startsWith('en')) {
        return _super_app_media_cms_en.format(args) as unknown as string;
    }

    return _super_app_media_cms_fr.format(args) as unknown as string;
}
